export const translations = {
  en: {
    nav: {
      home: 'Home', team: 'Our Team', services: 'Services', pricing: 'Pricing', goals: 'Our Goals', screenshots: 'Screenshots', contact: 'Contact'
    },
    hero: {
      title: 'We are here for your needs wherever you are',
      col1: 'Website Development', col2: 'Social Media Promotion', col3: 'Web Hosting',
      cta: 'Contact Us'
    },
    services: {
      title: 'Grow your Business - Get more customers today!',
      desc: 'Traffic leads to leads, and leads lead to sales and profit. By utilizing advanced SEO and targeted marketing strategies, we ensure your business reaches the right audience at the right time.',
      provideTitle: 'What We Provide',
      items: ['Responsive Websites', 'eCommerce Stores', 'Blog Management', 'Social Media Content', 'SEO Optimization', 'Google Ads Promotion']
    },
    features: {
      f1: 'Building & Support', f2: '100% Responsive', f3: 'SEO & Marketing', f4: '24/7 Support'
    },
    team: {
      title: 'Meet Our Team',
      m1: { role: 'SEO & Google Ads Specialist', bio: 'Expert in driving organic traffic and managing high-ROI ad campaigns.' },
      m2: { role: 'Front-End Developer', bio: 'Crafting pixel-perfect, responsive, and blazing fast user interfaces.' },
      m3: { role: 'Social Media & Designer', bio: 'Creating engaging visual content and managing brand presence.' }
    },
    trust: {
      whyUsTitle: 'Why Choose Us',
      whyUsDesc: 'We focus on quality over quantity, building personal relationships with our clients to ensure long-term, sustainable results.',
      extraFeatures: ['Instant Support (24/7)', 'Blog Management', 'Reliable Hosting']
    },
    pricing: {
      title: 'Simple, Transparent Pricing',
      from: 'from',
      p1: { name: 'Website Design', price: '180€', f1: 'Custom UI/UX Design', f2: 'Mobile Responsive', f3: 'Basic On-page SEO' },
      p2: { name: 'Promotion', price: '140€', f1: 'Social Media Management', f2: 'Google Ads Setup', f3: 'Monthly Analytics' },
      p3: { name: 'Hosting', price: '95€', f1: 'High-Speed Servers', f2: 'Free SSL Certificate', f3: 'Daily Backups' }
    },
    process: {
      title: 'Our Proven Process',
      s1: 'Analyze business', s2: 'Identify competitors', s3: 'Build strategy', s4: 'Deliver results'
    },
    contact: {
      title: 'Get In Touch',
      name: 'Full Name', email: 'Email Address', phone: 'Phone Number', message: 'Your Message', send: 'Send Message',
      info: 'Contact Information', location: 'Office Location'
    },
    footer: {
      terms: 'Terms of Service', cookies: 'Cookies Policy', rights: 'All rights reserved.'
    }
  },
  el: {
    nav: {
      home: 'Αρχική', team: 'Η Ομάδα μας', services: 'Υπηρεσίες', pricing: 'Τιμές', goals: 'Στόχοι', screenshots: 'Screenshots', contact: 'Επικοινωνία'
    },
    hero: {
      title: 'Είμαστε εδώ για τις ανάγκες σας όπου και αν βρίσκεστε',
      col1: 'Κατασκευή Ιστοσελίδων', col2: 'Προώθηση Social Media', col3: 'Φιλοξενία Website',
      cta: 'Επικοινωνήστε μαζί μας'
    },
    services: {
      title: 'Αναπτύξτε την επιχείρησή σας - Αποκτήστε περισσότερους πελάτες σήμερα!',
      desc: 'Η επισκεψιμότητα φέρνει leads, και τα leads φέρνουν πωλήσεις και κέρδος. Χρησιμοποιώντας προηγμένες στρατηγικές SEO και στοχευμένο marketing, διασφαλίζουμε ότι η επιχείρησή σας προσεγγίζει το σωστό κοινό.',
      provideTitle: 'Τι Παρέχουμε',
      items: ['Responsive Websites', 'eCommerce Stores', 'Διαχείριση Blog', 'Περιεχόμενο Social Media', 'Βελτιστοποίηση SEO', 'Προώθηση Google Ads']
    },
    features: {
      f1: 'Κατασκευή & Υποστήριξη', f2: '100% Responsive', f3: 'SEO & Marketing', f4: 'Υποστήριξη 24/7'
    },
    team: {
      title: 'Η Ομάδα Μας',
      m1: { role: 'Ειδικός SEO & Google Ads', bio: 'Ειδικός στην αύξηση οργανικής επισκεψιμότητας και διαχείριση διαφημίσεων.' },
      m2: { role: 'Front-End Developer', bio: 'Δημιουργία γρήγορων, responsive και άψογων διεπαφών χρήστη.' },
      m3: { role: 'Social Media & Designer', bio: 'Δημιουργία οπτικού περιεχομένου και διαχείριση social media.' }
    },
    trust: {
      whyUsTitle: 'Γιατί Να Μας Επιλέξετε',
      whyUsDesc: 'Εστιάζουμε στην ποιότητα έναντι της ποσότητας, χτίζοντας προσωπικές σχέσεις με τους πελάτες μας για μακροπρόθεσμα αποτελέσματα.',
      extraFeatures: ['Άμεση Υποστήριξη (24/7)', 'Διαχείριση Blog', 'Αξιόπιστη Φιλοξενία']
    },
    pricing: {
      title: 'Ξεκάθαρες Τιμές',
      from: 'από',
      p1: { name: 'Κατασκευή Ιστοσελίδας', price: '180€', f1: 'Custom Σχεδιασμός', f2: 'Mobile Responsive', f3: 'Βασικό SEO' },
      p2: { name: 'Προώθηση', price: '140€', f1: 'Διαχείριση Social Media', f2: 'Google Ads', f3: 'Μηνιαία Reports' },
      p3: { name: 'Φιλοξενία', price: '95€', f1: 'Γρήγοροι Servers', f2: 'Δωρεάν SSL', f3: 'Καθημερινά Backups' }
    },
    process: {
      title: 'Η Διαδικασία Μας',
      s1: 'Ανάλυση επιχείρησης', s2: 'Ανταγωνισμός', s3: 'Στρατηγική', s4: 'Αποτελέσματα'
    },
    contact: {
      title: 'Επικοινωνία',
      name: 'Ονοματεπώνυμο', email: 'Email', phone: 'Τηλέφωνο', message: 'Το μήνυμά σας', send: 'Αποστολή',
      info: 'Στοιχεία Επικοινωνίας', location: 'Τοποθεσία Γραφείου'
    },
    footer: {
      terms: 'Όροι Χρήσης', cookies: 'Πολιτική Cookies', rights: 'Με επιφύλαξη παντός δικαιώματος.'
    }
  }
};